<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e2112761" style="color: #82a339"><b>HONEYDEW AND LIME SOUP</b></p>
<p class="ext" id="d7e2113261"><b><i>This chilled soup starts a summer meal off with a refreshing mix of surprising flavors. Choose a melon that is fully ripe for a smooth consistency.</i></b></p>
<p class="h4" id="d7e2114561" style="color: #496210"><b>Prep: 10 minutes, plus chilling</b></p>
<p class="ul" id="d7e2115161">1 honeydew melon (5 pounds), chilled, <br/> cut into 1-inch chunks (8 cups)</p>
<p class="ul" id="d7e2115761">¼ cup fresh lime juice</p>
<p class="ul" id="d7e2116661">¼ cup loosely packed fresh cilantro leaves</p>
<p class="ul" id="d7e2117661">1 teaspoon jalapeño hot sauce</p>
<p class="ul" id="d7e2118261">⅛ teaspoon salt</p>
<p class="pub" id="d7e2119361" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In blender, pulse melon with lime juice, cilantro, hot sauce, and salt until pureed. Transfer soup to large bowl or pitcher; cover and refrigerate 2 hours or until chilled. Stir before serving. Makes about 6 cups or 6 servings.</p>
<p class="ntx" id="d7e2121561">Each serving: About 85 calories, 1g protein, 23g carbohydrate, 0g total fat, 2g fiber, 0mg cholesterol, 80mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c60_r1.vue?14342196